<template>
  <div class="container py-5" style="max-width: 600px">
    <h2 class="mb-4">Editar Vaga</h2>

    <form @submit.prevent="salvarVaga">
      <div class="mb-3">
        <label class="form-label">Título</label>
        <input v-model="vaga.titulo" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Descrição</label>
        <textarea v-model="vaga.descricao" class="form-control" rows="3" required></textarea>
      </div>

      <div class="mb-3">
        <label class="form-label">Requisitos</label>
        <textarea v-model="vaga.requisitos" class="form-control" rows="2" required></textarea>
      </div>

      <div class="mb-3">
        <label class="form-label">Local</label>
        <input v-model="vaga.local_trabalho" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Núcleo Regional</label>
        <input v-model="vaga.nucleo_regional" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Formato</label>
        <input v-model="vaga.formato" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Modalidade</label>
        <input v-model="vaga.modalidade_contratacao" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Jornada</label>
        <input v-model="vaga.jornada" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Faixa Salarial</label>
        <input v-model="vaga.faixa_salarial" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Prazo</label>
        <input v-model="prazo" type="date" class="form-control" required />
      </div>

      <!-- NOVO CAMPO -->
      <div class="mb-3">
        <label class="form-label">Aprovado(s)</label>
        <input
          v-model="vaga.aprovado"
          type="text"
          class="form-control"
          placeholder="Nome(s) do(s) aprovado(s)"
        />
      </div>

      <div class="mb-3">
        <label class="form-label">Status</label>
        <select v-model="vaga.statuss" class="form-select">
          <option value="aberta">aberta</option>
          <option value="encerrada">encerrada</option>
          <option value="cancelada">cancelada</option>
        </select>
      </div>

      <button class="btn btn-primary w-100" type="submit">
        Salvar Alterações
      </button>
    </form>

    <div v-if="mensagem" class="alert mt-4" :class="mensagemTipo">
      {{ mensagem }}
    </div>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: 'EditarVagaVie',
  data() {
    return {
      vaga: {
        id: null,
        titulo: '',
        descricao: '',
        requisitos: '',
        local_trabalho: '',
        nucleo_regional: '',
        formato: '',
        modalidade_contratacao: '',
        jornada: '',
        faixa_salarial: '',
        statuss: 'aberta',
        prazo: '',
        aprovado: null // novo campo
      },
      prazo: '',
      mensagem: '',
      mensagemTipo: ''
    };
  },
  mounted() {
    this.carregarVaga();
  },
  methods: {
    async carregarVaga() {
      const id = this.$route.params.id;
      const res = await api.get(`buscar_vaga.php?id=${id}`);
      this.vaga = res.data;
      this.prazo = this.vaga.prazo ? this.vaga.prazo.substr(0, 10) : '';
    },
    async salvarVaga() {
      this.mensagem = '';
      this.mensagemTipo = '';

      try {
        await api.post('atualizar_vaga.php', {
          id: this.vaga.id,
          titulo: this.vaga.titulo,
          local: this.vaga.local_trabalho,
          descricao: this.vaga.descricao,
          requisitos: this.vaga.requisitos,
          formato: this.vaga.formato,
          modalidade: this.vaga.modalidade_contratacao,
          salario: this.vaga.faixa_salarial,
          jornada: this.vaga.jornada,
          nucleo_regional: this.vaga.nucleo_regional,
          statuss: this.vaga.statuss,
          prazo: this.prazo,
          aprovado: this.vaga.aprovado?.trim() || null
        });

        this.mensagem = 'Vaga atualizada com sucesso!';
        this.mensagemTipo = 'alert-success';
      } catch (error) {
        this.mensagem =
          error.response?.data?.erro || 'Erro ao atualizar vaga.';
        this.mensagemTipo = 'alert-danger';
      }
    }
  }
};
</script>
